module.exports = __webpack_public_path__ + "static/media/offer_tab.9736308c.png";